import React from "react";
import logoNordCom  from "./logo-white.svg"
export default class Header extends React.Component{ 
   constructor(props){ 
      super(props); 
   }
   render(){ 
      let user = sessionStorage.getItem('user');
      let showButton = true;
      user = JSON.parse(user);
      if(user!= null){
         showButton =true;
      }
      return( 
         <header className="bd-header bg-dark  border-bottom border-dark container-fluid" >
            <div className="row">
               <div className="col-md-4 mb-0">
                  <h1 className=" text-white"
                     onClick={()=>window.location.href="/#"}>
                     &nbsp;@EasyFine
                  </h1>
               </div>  
               <div className="  col-md-4 mb-0">
                  .
               </div> 
               <div className=" col-md-4 mb-0">
               <img src={logoNordCom} onClick={()=>window.location.href="/#"} className="rounded float-right" style={{marginLeft:"25px"}} alt="logo Nordcom"></img>
               </div>
            </div>
         </header>
      ); 
   }
}